import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@workspace/ng-config';
import { ApplicationStore } from '../ngrx';

export const ApplicationHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes(`${environment.auth.keycloak.host}/realms/`)) {
    return next(req);
  }
  const appStore = inject(ApplicationStore);
  const app = appStore.currentApplicationName();
  const cloned = app ? req.clone({ setHeaders: { application: app } }) : req;
  return next(cloned);
};
